<template>
    <b-container class="os-card">
    <h3 class="text-center mb-5">{{ $helpers.getMetaTitleText($route) }}</h3>
    <b-form class="container" @submit.stop.prevent="signup">
      <loading-anim v-if="$store.state.loading" :active="$store.state.loading" fullScreen></loading-anim>

      <b-alert show variant="danger" v-if="form.state.submitted && form.state.unauthorized">{{ submitError }}</b-alert>
      <b-alert show variant="danger" v-if="form.state.submitted && form.state.errors">{{$t('signupOH.errors.general-code')}}
      </b-alert>

    <b-form-group>
        <b-form-input type="text" v-model="$v.form.name.$model" :placeholder="$t('signupOH.registerNameCenter')" @input="resetForm()" :state="validateState('name')"></b-form-input>
        <b-form-invalid-feedback v-if="form.trySubmit" :state="form.name != null && form.name != ''">{{ $t('signupOH.errors.enterCentreName') }}</b-form-invalid-feedback>
      </b-form-group>

      <b-form-group>
        <b-form-input type="text" v-model="$v.form.sanitaryRegister.$model" :placeholder="$t('signupOH.registerSanitaryRegister')" @input="resetForm()" :state="validateState('sanitaryRegister')"></b-form-input>
        <b-form-invalid-feedback v-if="form.trySubmit" :state="form.sanitaryRegister != null && form.sanitaryRegister != ''">{{ $t('signupOH.errors.enterSanitaryRegister') }}</b-form-invalid-feedback>
      </b-form-group>

      <b-form-group>
        <b-form-input type="text" v-model="$v.form.codPromotion.$model" :placeholder="$t('signupOH.registerCodeEnt')" @input="resetForm()" :state="validateState('codPromotion')"></b-form-input>
        <!-- <b-form-invalid-feedback :state="form.codPromotion">{{ $t('signupOH.errors.enterCode') }}</b-form-invalid-feedback> -->
      </b-form-group>

      <b-form-group style="text-align:left">
          <b-form-checkbox
            id="genderForm"
            v-model="withoutLocation"
            name="genderForm"
          >
            {{ $t('signupOH.withoutLocation') }}
          </b-form-checkbox>
      </b-form-group>

      <b-form-group v-if="!withoutLocation">
              <base-select id="country" :searchable="true" v-model="$v.form.countryId.$model" :placeholder="$t('signupOH.country')" :options="selectedCountry.options" :label="$i18nHelpers.normalizeProp('name')" valueProp="idCountry" @change="reCallProvince" :errorMsg="$t('signupOH.errors.enterCountry')" :clearable="false"/>
              <!-- <base-select id="country" v-model="selectCountry.selected" :label="$i18nHelpers.normalizeProp('name')"
                :placeholder="$t('signupOH.country')" :options="selectCountry.options" valueProp="idCountry"></base-select> -->
        <b-form-invalid-feedback v-if="form.trySubmit" :state="form.countryId != null">{{ $t('signupOH.errors.enterCountry') }}</b-form-invalid-feedback>

      </b-form-group>

      <b-form-group v-if="!withoutLocation">
        <base-select id="province" v-model="$v.form.stateId.$model" :searchable="true" :placeholder="$t('signupOH.registerYourProvince')" :options="selectProvince.options" :label="$i18nHelpers.normalizeProp('name')" valueProp="id"></base-select>
        <b-form-invalid-feedback v-if="form.trySubmit" :state="form.stateId != null">{{ $t('signupOH.errors.enterProvince') }}</b-form-invalid-feedback>
      </b-form-group>
    
      <b-form-group>
        <b-form-input type="text" v-model="$v.form.email.$model" :placeholder="$t('signupOH.registerEmail')" @input="resetForm()" :state="validateState('email')"></b-form-input>
        <b-form-invalid-feedback v-if="form.trySubmit" :state="form.email != null">{{ $t('signupOH.errors.enterEmail') }}</b-form-invalid-feedback>
      </b-form-group>
      
      <b-form-group>
        <b-form-input type="text"  v-model="$v.form.emailConfirmation.$model" :placeholder="$t('signupOH.confirmEmail')" @input="resetForm()" :state="validateState('emailConfirmation')"></b-form-input>
        <b-form-invalid-feedback v-if="form.trySubmit" :state="form.emailConfirmation != null">{{ $t('signupOH.errors.enterConfirmEmail') }}</b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="form.trySubmit" :state="form.emailConfirmation == form.email">{{ $t('signupOH.errors.sameEmails') }}</b-form-invalid-feedback>
      </b-form-group>

      <b-form-group>
            <base-select id="discovery" v-model="form.discoveryCheck" :searchable="true" label="text" :placeholder="$t('signupOH.selectDiscovery')" :options="this.selectDiscovery.options"></base-select>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="form.discoveryCheck != null">{{ $t('signupOH.errors.enterDiscoveryType') }}</b-form-invalid-feedback>
          </b-form-group>
      <base-checkbox v-model="form.termsAccepted">
              <span v-html="$t('signupOH.accept-terms')"></span>
              <b-form-invalid-feedback v-if="form.trySubmit" :state="form.termsAccepted === true">{{ $t('signupOH.errors.termsAccepted') }}</b-form-invalid-feedback>
            </base-checkbox>
      <base-checkbox v-model="form.privacyAccepted">
            <span v-html="$t('signupOH.accept-privacy')"></span>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="form.privacyAccepted === true">{{ $t('signupOH.errors.privacyAccepted') }}</b-form-invalid-feedback>
      </base-checkbox>
      <base-checkbox v-model="form.dataVerification">
              <span v-html="$t('signupOH.data-verefication')"></span>
              <b-form-invalid-feedback v-if="form.trySubmit" :state="form.dataVerification === true">{{ $t('signupOH.errors.dataVerification') }}</b-form-invalid-feedback>
      </base-checkbox>
      <b-row class="align-items-center justify-content-center pb-3 text-center">
        <VueRecaptcha
        :sitekey="siteKey"
        :load-recaptcha-script="true"
        @verify="handleSuccess"
        @error="handleError"
        @expired="handleError"
      ></VueRecaptcha>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.captcha == true">{{ $t('signupOH.errors.captcha') }}</b-form-invalid-feedback>
      </b-row>
      <b-button type="submit" variant="primary" style="width: 100%">
        {{ $t('signupOH.signup-submit') }}
      </b-button>
      <hr>

      <span>{{ $t('signUp.already-registered') }}, <a style="cursor: pointer" class="log-in-a" @click="goLogin">{{ $t('sign-up-href') }}</a>.</span>
    </b-form>
    </b-container>
</template>

<script>
import { BForm, BFormGroup, BButton, BFormInvalidFeedback, BFormInput, BAlert, BModal, BFormCheckbox } from 'bootstrap-vue'
import BaseCheckbox from '@/components/base/forms/BaseCheckbox'
import BaseDatepicker from '@/components/base/forms/BaseDatepicker'
import RadioButtonGender from '../base/forms/RadioButtonGender.vue'
import '@/plugins/vue-select'
import { validationsMixin } from '@/mixins/validations.mixin'
import { required, numeric, email, sameAs } from 'vuelidate/lib/validators'
import { onlyTrue } from '@/plugins/customValidators'
import { VueRecaptcha } from 'vue-recaptcha'
import LoadingAnim from '@/components/utils/LoadingAnim'
import accountMixin from '@/mixins/account.mixin'
import { recaptcha } from '@/constants/recaptcha'
import geographyRepository from '@/repositories/GeographyRepository'
import { getDefaultCountryId } from '@/helpers/global.helpers'

export default {
  name: 'center-sign-up-form',
  mixins: [validationsMixin, accountMixin],
  components: {
    BForm,
    BModal,
    BFormCheckbox,
    BFormGroup,
    BButton,
    LoadingAnim,
    BFormInvalidFeedback,
    BFormInput,
    VueRecaptcha,
    BAlert,
    'base-radio-group': () => import('@/components/base/forms/BaseRadioGroup'),
    'base-select': () => import('@/components/base/forms/BaseSelect'),
    'base-multiSelect': () => import('@/components/base/forms/BaseMultiSelect'),
    BaseCheckbox,
    'radio-button-gender': RadioButtonGender,
    BaseDatepicker
  },
  props: {
    callback: {
      type: Function,
      required: false
    },
    role: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      siteKey: recaptcha,
      visibleModal: false,
      withoutLocation: false,
      form: {
        captcha: false,
        trySubmit: false,
        codPromotion: null,
        name: null,
        sanitaryRegister: null,
        email: null,
        emailConfirmation: null,
        countryId: null,
        stateId: null,
        termsAccepted: false,
        privacyAccepted: false,
        dataVerification: false,
        state: {
          waiting: false,
          unauthorized: false,
          errors: false,
          submitted: false
        }
      },
      binRadioGroup: {
        selected: null
      },
      selectedCountry: {
        selected: null,
        options: []
      },
      selectProvince: {
        selected: null,
        options: []
      },
      selectDiscovery: {
        selected: null,
        options: [
          { value: '1', text: this.$t('signupDiscovery.title1') },
          { value: '2', text: this.$t('signupDiscovery.title2') },
          { value: '3', text: this.$t('signupDiscovery.title3') },
          { value: '4', text: this.$t('signupDiscovery.title4') },
          { value: '5', text: this.$t('signupDiscovery.title5') },
          { value: '6', text: 'Email' },
          { value: '7', text: this.$t('signupDiscovery.title7') },
          { value: '8', text: this.$t('signupDiscovery.title8') },
          { value: '9', text: this.$t('signupDiscovery.title9') },
          { value: '10', text: this.$t('signupDiscovery.title10') },
          { value: '11', text: this.$t('signupDiscovery.title11') }
        ]
      },
      errors: {
        email: null,
        password: null
      },
      submitError: null
    }
  },
  validations: {
    form: {
      name: {
        required,
        validateName () {
          return (!!this.form.name && this.form.name !== '')
        }
      },
      sanitaryRegister: {
        required,
        validateSanitaryRegister () {
          return (this.form.sanitaryRegister != null && this.form.sanitaryRegister !== '')
        }
      },
      codPromotion: {
      },
      email: {
        required,
        email,
        validateEmail () {
          return (!!this.form.email && this.form.email !== '')
        }
      },
      emailConfirmation: {
        required,
        email,
        sameAsEmail: sameAs('email'),
        validateEmailConfirmation () {
          return (this.form.emailConfirmation != null && !!this.form.emailConfirmation)
        }
      },
      countryId: {
        validCountryId () {
          return this.withoutLocation === true || (this.form && this.form.countryId != null && this.form.countryId !== '')
        },
        numeric
      },
      stateId: {
        validStateId () {
          return this.withoutLocation === true || (this.form && this.form.stateId != null && this.form.stateId !== '')
        },
        numeric
      },
      termsAccepted: {
        required,
        onlyTrue
      },
      captcha: {
        required,
        onlyTrue
      },
      discoveryCheck: {
        required
      },
      privacyAccepted: {
        required,
        onlyTrue
      },
      dataVerification: {
        required,
        onlyTrue
      }
    }
  },
  methods: {
    handleError: function () {
      this.form.captcha = false
      },
     handleSuccess: function () {
       this.form.captcha = true
      },
    validateState (prop) {
      /* eslint-disable no-unused-vars */
      const { $dirty, $error } = this.$v.form[prop]
      return $dirty ? !$error : null
    },
    builtInOkFn () {
      this.visibleModal = false
      this.$router.go(this.$router.currentRoute)
    },
    validateEmail: function (email) {
      var re = /^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/
      if (!re.test(email)) {
        return false
      } else {
        return true
      }
    },
    validateText: function (text) {
      var re = /^[A-Za-zÀ-ÖØ-öø-ÿ]+$/i
      if (!re.test(text)) {
        return false
      } else {
        return true
      }
    },
    reCallProvince: function () {
      geographyRepository.getStatesByCountry(this.selectedCountry.selected).then((response) => {
      this.selectProvince.options = response.data
    })
    },
    signup: function () {
      const _this = this
      this.resetForm()
      this.form.trySubmit = true
      this.form.state.submitted = true
      this.form.state.waiting = true
      if (this.formIsValid()) {
        this.$api.post('/CreateCenter', {
          ClientReturnUrl: encodeURIComponent(_this.$route.query.returnUrl || (_this.$route.query.ReturnUrl || null)),
          role: 'Centro',
          firstName: this.form.name.trim(),
          withoutLocation: this.withoutLocation,
          codPromotion: this.form.codPromotion,
          sanitaryRegister: this.form.sanitaryRegister.trim(),
          idCountry: this.withoutLocation ? null : this.form.countryId,
          idProvince: this.withoutLocation ? null : this.form.stateId,
          idHowToMeet: this.form.discoveryCheck,
          email: this.form.email.toLowerCase()
          }).then((response) => {
          this.defaultLoginCallback(response)
        }).catch(function () {
          _this.form.state.errors = true
          _this.form.state.waiting = false
          return this.$router.push({ path: '/cuenta/registro-correcto', query: { email: this.form.email.trim(), confirmSucessful: false } })
        })
      } else {
        _this.form.state.waiting = false
      }
    },
    defaultLoginCallback (response) {
      if (response) {
        switch (response.status) {
          case 200:
            // window.location = response.data.url
            return this.$router.push({ path: '/cuenta/registro-correcto', query: { email: this.form.email.trim(), confirmSucessful: true } })
          case 403:
            this.submitError = response.data.message
            this.form.state.unauthorized = true
            this.form.state.waiting = false
            break
          case 400:
            this.submitError = this.$t('error-alreadyregister')
            this.form.state.unauthorized = true
            this.form.state.waiting = false
            break
          case 405:
            this.submitError = this.$t('invalidPromotionCode')
            this.form.state.unauthorized = true
            this.form.state.waiting = false
            break
          default:
            this.form.state.errors = true
            this.form.state.waiting = false
            break
        }
      } else {
        this.form.state.errors = true
        this.form.state.waiting = false
      }
    },
    resetForm: function () {
      this.form.state.submitted = false
      this.form.state.waiting = false
      this.form.state.unauthorized = false
      this.form.state.errors = false
    }
  },
  computed: {
    emailValidation: function () {
      return this.$validators.validate(this.form.email, ['required', 'email'], this.form.state.submitted)
    },
    passwordValidation: function () {
      return this.$validators.validate(this.form.password, ['required'], this.form.state.submitted)
    }
  },
  async mounted () {
    await geographyRepository.getCountries().then((response) => {
      this.selectedCountry.options = response.data
      this.selectedCountry.selected = getDefaultCountryId()
      const selectedCountryId = this.selectedCountry.options.find(country => country.idCountry === this.selectedCountry.selected)
      this.form.countryId = selectedCountryId.idCountry

			geographyRepository.getStatesByCountry(this.form.countryId).then((response) => {
				this.selectProvince.options = response.data
			})
    })
  }
}
</script>

<style lang="scss" scoped>
.os-card {
  @include desktop {
    padding: 3rem 6rem;
  }
  @include desktop-sm {
    padding: 3rem 6rem;
  }
  @include tablets {
    padding: 3rem 6rem;
  }
  @include mobile {
    padding: 3rem 1rem;
    h3{
      font-size: 1.3rem;
    }
  }
  border-radius: $border-radius !important;
  box-shadow: $custom-shadow;
  margin: {
    bottom: 2rem;
  }
}
.log-in-a{
  color: $blue !important
}
  span .vs__selected{
    margin-left: 1%;
    font-size: 0.8rem;    
  }

  .v-select {
    // margin: 2% 0px 2% 0px !important;
    margin-top: 0px !important;
    margin-bottom: 0px !important;

  }
  .vs__selected{
  margin-left: 1rem !important;
  padding: 0 0.8em !important;
  }

  .form-group{
    margin: 2% 0px 2% 0px !important;
  }

  div .v-select .vs--unsearchable{
    margin: 0px !important;
  }

  .vs__selected, .vs__search, .vs__search:focus {
  margin-left: 1rem !important;
  
  }

  .v-select .vs--single .vs--unsearchable{
        margin: 0px !important;
  }

  div .mt-3, button, p, fieldset, .v-select, .custom-checkbox, .my-3 {
      margin-top: 0rem !important;
  }

  #lang{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }
    #prefix{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }
    #country{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }
    #province{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }

  #genderForm{
    // display: inline-flex;
    text-align: left !important;
  }

  .genderText{
    float: left;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.6;
    color: #495057;
    padding: 0rem 2.2rem;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    // margin-right: auto !important;
    // margin-left: auto !important;
  }

  @media (max-width: 1024px) {
    .Body1_OH-sm{
    display:block !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    }
  }



  .headerMenu {
    margin: 22px 133px 0px 4% ;
    // line-height: 2.70 !important;
    // display: block !important;
    // @media (max-width: 1024px) {
    //   margin: auto !important;
    // }
  }

  div  .Body3_rightCol{
      padding-right: 0px !important;
      padding-left: 0px !important;      
  }

  .Body2_OH {
    margin: 5% 0% 0% 12% !important;
}
.Body3_div {
    display: block;
    padding: 8% 0px 8% 10% !important;;
    background-color: #1D1D1E;
    opacity: 87%;
    margin: 0px 0% 0px 0px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/forms/CentersSignupForm.vue